import { fetchWrapper } from "_helpers";

const baseUrl = `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_CONTEXT_PATH}`;

export const extraService = {
  getPlants,
  uploadPackingList,
  uploadSummaryPackingList,
  uploadMaterialRequest,
  uploadStockIssue,
  uploadStockCount,
  uploadStockDetailsUpdate,
  testEmail,
  getBarcode,
  getQualityTypes,
};

function getPlants() {
  return fetchWrapper.get(`${baseUrl}/plants/suggestion`);
}

function uploadPackingList(params) {
  return fetchWrapper.post(`${baseUrl}/packinList/upload`, params);
}

function uploadSummaryPackingList(params) {
  return fetchWrapper.post(`${baseUrl}/stockReceipt/uploadSummary`, params);
}

function uploadMaterialRequest(params) {
  return fetchWrapper.post(`${baseUrl}/stockIssueRequest/upload`, params);
}

function uploadStockIssue(params) {
  return fetchWrapper.post(`${baseUrl}/stockIssue/upload`, params);
}

function uploadStockCount(params) {
  return fetchWrapper.post(`${baseUrl}/stockCount/upload`, params);
}

function uploadStockDetailsUpdate(params) {
  return fetchWrapper.post(`${baseUrl}/stockUpdate/upload`, params);
}

function getBarcode() {
  return fetchWrapper.get(`${baseUrl}/barcodes`);
}

function testEmail(params) {
  return fetchWrapper.post(`${baseUrl}/testEmail`, {}, params);
}

function getQualityTypes() {
  return fetchWrapper.get(`${baseUrl}/quality-type/suggestion`);
}

/* , {
  headers: {
    "Content-Type": "multipart/form-data",
  },
} */
